import React from 'react';
import type { FC } from 'react';
import { Button, ButtonType, ButtonSize } from './button';
import ReactDOM from 'react-dom';
import { Modal } from './modal';

export enum ConfirmationModalType {
    WARN = 'WARN',
    DEFAULT = 'DEFAULT',
}

interface ConfirmationModalProps {
    type: ConfirmationModalType;
    onCancel?: () => void;
    onConfirm?: () => void;
    confirmText: string;
    cancelText: string;
    message: string;
    subMessage?: string;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
    onCancel,
    onConfirm,
    confirmText,
    cancelText,
    message,
    subMessage,
    isOpen,
    setIsOpen,
    type,
}) => {
    return (
        <Modal isOpen={isOpen}>
            <div className="flex flex-col absolute min-w-96 w-[38vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out">
                <div className="flex flex-col p-4 gap-2">
                    <p className="text-xl text-white">{message}</p>
                    {subMessage && <p className="text-sm text-white">{subMessage}</p>}
                </div>
                <hr className="bg-gray-100 border-gray-120" />
                <div className="w-full flex flex-row justify-end gap-3 p-6">
                    <Button
                        title={cancelText}
                        className="px-5"
                        buttonType={ButtonType.SECONDARY}
                        buttonSize={ButtonSize.LARGE}
                        onClick={() => {
                            setIsOpen(false);
                            onCancel?.();
                        }}
                    />
                    <Button
                        title={confirmText}
                        buttonType={ButtonType.PRIMARY}
                        className={`${type === ConfirmationModalType.DEFAULT ? 'bg-blue-60' : 'bg-red-50'} text-white px-8`}
                        buttonSize={ButtonSize.LARGE}
                        onClick={() => {
                            setIsOpen(false);
                            onConfirm?.();
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};
